import { Button, Divider, Form, Input, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import foreignRequest from "../../foreignRequest";
import { colors } from "../../../../../Utils/temas";

export const SelectCamposRef = ({ openModal, onCancel, onSelecionado }) => {
  const [campoSelecionado, setCampoSelecionado] = useState({});
  const [filtros, setFiltros] = useState({});

  const [campos, setCampos] = useState();

  const [totalRecords, setTotalRecords] = useState(0);

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCampos(1, 10, filtros);
  }, [filtros]);

  const columnsCampo = [
    {
      title: "Nome",
      dataIndex: "nome",
    },
    { title: "Domínio", dataIndex: "nome_dominio" },
    { title: "Tabela", dataIndex: "nome_tabela" },
  ];

  const selecionarLinha = (selectedRowKeys, selectedRows) => {
    setCampoSelecionado(selectedRows[0]);
  };

  const handleOk = () => {
    onSelecionado(campoSelecionado);
  };

  const getCampos = async (page, pageSize, params) => {
    setLoading(true);
    try {
      const response = await foreignRequest.getCampos(page, pageSize, params);
      if (response.status === 200) {
        const { results, count } = response.data;
        setCampos(results);
        setTotalRecords(count);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onPesquisarClick = (values) => {
    setFiltros(values);
  };

  const onLimpar = () => {
    setFiltros({});
    form.resetFields();
  };

  return (
    <Modal visible={openModal} onCancel={onCancel} width="50%" onOk={handleOk}>
      <Form form={form} layout="vertical" onFinish={onPesquisarClick}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "30%" }}>
            <Form.Item
              name="dominio_nome"
              label="Domínio"
              style={{ fontWeight: "500" }}
            >
              <Input />
            </Form.Item>
          </div>

          <div style={{ width: "30%" }}>
            <Form.Item name="nome" label="Campo:" style={{ fontWeight: "500" }}>
              <Input />
            </Form.Item>
          </div>

          <div style={{ width: "30%" }}>
            <Form.Item
              name="tabela_nome"
              label="Tabela:"
              style={{ fontWeight: "500" }}
            >
              <Input />
            </Form.Item>
          </div>
        </div>

        <Divider />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            htmlType="submit"
            icon={<SearchOutlined />}
            style={{
              background: colors.secondary,
              color: "white",
              fontWeight: "500",
            }}
            className="botao"
          >
            Pesquisar
          </Button>
          <Button icon={<CloseOutlined />} onClick={onLimpar}>
            Limpar
          </Button>
        </div>

        <div style={{ marginTop: 20 }}>
          <Table
            columns={columnsCampo}
            rowKey="id"
            rowSelection={{
              type: "radio",
              onChange: selecionarLinha,
            }}
            pagination={{
              total: totalRecords,
              showTotal: (total) => (
                <span
                  style={{ fontWeight: "500", position: "absolute", left: "4%" }}
                >
                  Quantidade: {total}
                </span>
              ),
              onChange: (page, pageSize) => getCampos(page, pageSize, filtros),
            }}
            dataSource={campos}
            loading={loading}
          />
        </div>
      </Form>
    </Modal>
  );
};
